export const initialValues = {
    toName: '',
    toPhone: '',
    toPhoneConfirm: '',
    toEmail: '',
    toEmailConfirm: '',

    fromName: '',
    fromPhone: '',
    fromEmail: '',

    message: '',

    variant: {
        id: '',
        title: '',
        price: 0,
        fee: 495,
    },

    quantity: 1,
    deliveryMethod: 'Text',
    deliveryDate: '',
    giftCardType: 'choose_your_own_restaurant',
};
